import { useDialog } from '@dni-hooks/useDialog'
import { Button } from '@pets-ui/Button/Button'
import { Dialog } from '@pets-ui/Dialog/Dialog'
import { DialogActions } from '@pets-ui/DialogActions/DialogActions'
import { DialogContent } from '@pets-ui/DialogContent/DialogContent'
import { DialogHeader } from '@pets-ui/DialogHeader/DialogHeader'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { useState } from 'react'

export const DIALOG_CONFIRM_CANCEL_ORDER = 'DIALOG_CONFIRM_CANCEL_ORDER'

export interface DialogConfirmCancelOrderExtraProps {
  transactionId: string
  onConfirm?: () => void | Promise<void>
}

export function DialogConfirmCancelOrder() {
  const { open, closeDialog, transactionId, onConfirm } = useDialog<DialogConfirmCancelOrderExtraProps>(DIALOG_CONFIRM_CANCEL_ORDER)
  const [isSubmitting, setIsSubmitting] = useState(false)

  async function handleConfirm() {
    setIsSubmitting(true)
    try {
      await onConfirm?.()
    }
    finally {
      setIsSubmitting(false)
      closeDialog()
    }
  }

  return (
    <Dialog onClose={closeDialog} open={open} maxWidth={320} fullWidth>
      <DialogHeader align="center" title="確認取消訂單" />
      <DialogContent>
        <Text color={colors.grey800}>
          取消交易編號
          {' '}
          {transactionId}
          {' '}
          後，將無法恢復訂單，是否繼續取消？
        </Text>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeDialog} variant="outlined" color="grey" fullWidth disabled={isSubmitting}>捨棄</Button>
        <Button onClick={handleConfirm} variant="filled" color="primary" fullWidth loading={isSubmitting}>確認</Button>
      </DialogActions>
    </Dialog>
  )
}
